import { StyleSheet, TouchableOpacity, View } from "react-native";
import React from "react";
import { BottomTabBarProps } from "@react-navigation/bottom-tabs";
import { FontAwesome, AntDesign, Ionicons } from "@expo/vector-icons";
import { Text, useTheme } from "react-native-paper";
import ID from "../screens/HomeStack/ID";
const BottomTabNav = ({
	state,
	navigation,
	descriptors,
}: BottomTabBarProps) => {
	const { colors } = useTheme();
	const customStyle =
		descriptors?.[state.routes?.[state.index]?.key]?.options?.tabBarStyle;

	return (
		<View style={[styles.root, customStyle as any]}>
			{state.routes.map((route, index) => {
				const { options } = descriptors[route.key];

				const label =
					options.tabBarLabel !== undefined
						? options.tabBarLabel
						: options.title !== undefined
						? options.title
						: route.name;

				const isFocused = state.index === index;

				const onPress = () => {
					const event = navigation.emit({
						type: "tabPress",
						target: route.key,
						canPreventDefault: true,
					});

					if (!isFocused && !event.defaultPrevented) {
						navigation.navigate(route.name);
					}
				};
				const Icon = index;
				const onLongPress = () => {
					navigation.emit({
						type: "tabLongPress",
						target: route.key,
					});
				};

				if (index === 6 || index === 7) {
					return null;
				}

				return (
					<TouchableOpacity
						key={index}
						accessibilityRole="button"
						accessibilityLabel={options.tabBarAccessibilityLabel}
						testID={options.tabBarTestID}
						onPress={onPress}
						onLongPress={onLongPress}
						style={styles.tab}
					>
						{index === 2 ? (
							<AntDesign
								name="tago"
								size={24}
								style={
									isFocused ? { color: colors.primary } : styles.notFocused
								}
							/>
						) : index === 3 ? (
							<Ionicons
								name="settings"
								size={24}
								style={
									isFocused ? { color: colors.primary } : styles.notFocused
								}
							/>
						) : (
							<FontAwesome
								name={index === 0 ? "home" : "id-card-o"}
								size={24}
								style={
									isFocused ? { color: colors.primary } : styles.notFocused
								}
							/>
						)}
						{isFocused && (
							<View
								style={[styles.focusedTab, { backgroundColor: colors.primary }]}
							></View>
						)}
						<Text
							numberOfLines={1}
							style={[
								styles.label,
								isFocused ? { color: colors.primary } : styles.notFocused,
							]}
						>
							{label}
						</Text>
					</TouchableOpacity>
				);
			})}
		</View>
	);
};

export default BottomTabNav;

const styles = StyleSheet.create({
	root: {
		width: "90%",
		height: 60,
		position: "absolute",
		bottom: 15,
		backgroundColor: "#fff",
		marginHorizontal: "5%",
		borderRadius: 18,
		shadowColor: "#000",
		shadowOffset: {
			width: 0,
			height: 2,
		},
		shadowOpacity: 0.25,
		shadowRadius: 3.84,
		flexDirection: "row",
		// Six tabs have to fit on a phone-width screen; the labels overlapped
		// each other (and covered the last tab's touch target) at the previous
		// padding and default font size.
		paddingHorizontal: 10,
		alignItems: "center",
		zIndex: 5,
	},

	notFocused: {
		color: "#c3cecf",
	},
	label: {
		fontSize: 10,
		lineHeight: 14,
		textAlign: "center",
		width: "100%",
	},
	tab: {
		flex: 1,
		alignItems: "center",
		marginTop: 10,
	},
	focusedTab: {
		position: "absolute",
		top: -12,
		width: 20,
		height: 5,

		borderRadius: 3,
	},
});
